import { Link } from 'react-router-dom';
import styled, { type DefaultTheme } from 'styled-components';

import { Breakpoint, defaultTheme, resizedAssetUrl, tokens } from '@treams/treams-ui';

// Inlining this caused issues with ts-styled-plugin (it disallows line breaks, not escaping the template literal)
const logoImageFromTheme = (theme: DefaultTheme) =>
	resizedAssetUrl(theme.images.logo, { width: 300, height: 100, fit: 'contain' });

const ClientLogo = styled(Link)<{ $withPoweredBy?: boolean }>`
	background-image: url('${(props) => logoImageFromTheme(props.theme)}');
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	width: 100%;
	max-width: 100px;
	height: 50px;
	display: inline-block;
	vertical-align: top;

	${(props) =>
		props.$withPoweredBy &&
		`
		@media screen and (min-width: ${Breakpoint.Medium}) {
			margin-right: 20px;
		}
	`}
`;

const PoweredByContainer = styled(Link)`
	display: inline-block;
	vertical-align: top;
	text-align: left;
	text-decoration: none;

	p {
		font-size: 10px;
		color: ${tokens.text.secondary};
		margin-bottom: 0;
	}

	@media screen and (max-width: 900px) {
		display: none;
	}
`;

const PoweredByLogo = styled.div`
	background-image: url(/images/treams-logo-black.svg);
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
	width: 100px;
	height: 40px;
	margin-top: -8px;
`;

interface IProps {
	to: string;
	onClick?: () => void;
}

export default function Logo({ to, onClick }: IProps) {
	const withPoweredBy = !defaultTheme.images.logo.endsWith('treams_logo.svg');

	return (
		<>
			<ClientLogo to={to} onClick={onClick} $withPoweredBy={withPoweredBy} />

			{withPoweredBy && (
				<PoweredByContainer to={to} onClick={onClick}>
					<p>Empowered by</p>
					<PoweredByLogo />
				</PoweredByContainer>
			)}
		</>
	);
}
